/**
 * Sets the current offset top as a data sttribute. Needed because of `position: sticky`
 */
function setCardsOffsetTop() {
	const cards = document.querySelectorAll( '.faq-card' );

	if ( cards.length ) {
		[...cards].forEach( ( element ) => {
			element.setAttribute( 'data-offset-top', element.offsetTop );
		} );
	}
}

/**
 * Binds the click listener of TOC items. Pulls data from 'connected' FAQ card
 */
function bindTocItemClick() {
	const tocItems = document.querySelectorAll( '.toc-item' );

	if ( tocItems.length ) {
		[...tocItems].forEach( ( element ) => {
			element.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				unActiveTocItems( tocItems );
				activeTocItem( element );

				const scrollToElement = element.getAttribute( 'data-faq-card' ),
					scrollDistance = document.querySelector( '#' + scrollToElement ).getAttribute( 'data-offset-top' );

				window.scrollTo( {
					top: scrollDistance,
					behavior: 'smooth',
				} );
			} );
		} );
	}
}

/**
 * Disables all TOC items
 *
 * @param items
 */
function unActiveTocItems( items ) {
	[...items].forEach( ( element ) => {
		element.classList.remove( 'active' );
	} );
}

/**
 * Activate a single TOC item
 *
 * @param item
 */
function activeTocItem( item ) {
	item.classList.add( 'active' );
}

export default {
	init() {
		// window.onload = ( event ) => {
			bindTocItemClick();
			setCardsOffsetTop();
		// };
	},
};